import ouiStyle from '@goldwasserexchange/oui-style';
import * as React from 'react';
import {
  ArticleSearchContainer,
  ArticleSearchButton,
  ArticleSearchInput,
  ArticleSearchWrapper,
} from './components';
import { ArticleSearchProvider } from './context';

export const ArticleSearchBox = (props: {
  initialValue?: string,
  borderColor?: ouiStyle.InStyle['borderColor'],
  widthLines?: ouiStyle.InStyleWithMediaQueries['widthLines'],
  onChange?: (value: string) => void,
}) => {
  const {
    initialValue,
    borderColor,
    widthLines,
    onChange,
  } = props;
  return (
    <ArticleSearchProvider
      initialValue={initialValue}
      onChange={onChange}
    >
      <ArticleSearchWrapper
        widthLines={widthLines}
      >
        <ArticleSearchContainer
          borderColor={borderColor}
        >
          <ArticleSearchInput />
        </ArticleSearchContainer>
        <ArticleSearchButton
          borderColor={borderColor}
        />
      </ArticleSearchWrapper>
    </ArticleSearchProvider>
  );
};
